<template>
  <CScrollbar
    class="navigation navigation-main h-100" id="main-menu-navigation" data-menu="menu-navigation"
    :settings="psSettings"
    tag="ul"
  >
    <slot></slot>
  </CScrollbar>
</template>

<script>
import CScrollbar from './CScrollbar'

export default {
  name: 'CSidebarNav',
  components: {
    CScrollbar
  },
  inject: {
    state: {
      default: false
    }
  },
  computed: {
    psSettings () {
      // ToDo: find better rtl fix
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
        wheelPropagation: false
      }
    }
  }
}
</script>

